import styled from 'styled-components';

const Divider = styled.div`
  height: 1px;
  width: 100%;
  background-color: #a3a3a3;
`;

export default Divider;
